import ApiService from './ApiService.js';
const uuidv1 = require('uuid/v1');
import moment from 'moment'
var FilterService = {
    findAll: function($keyType)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="getFilter/"+$keyType
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

     },
    
     saveFilters: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data=$data
            console.log($data)
            
          
            $options.url ="filter"
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },


}
    
export default FilterService;